module.exports = __webpack_public_path__ + "img/首页轮播图1.f6fc003f.jpg";